/**
 * What the panel sends when a watched video is finished, and when reaching the end counts as
 * finishing. Plain .ts so `node --test` can load it.
 */
import type { VideoBinding } from "./videoBinding.ts";

/** Finishing a video is only worth saying where the work is kept, so only under a project. */
export function closingFor(closing: string | null, projectId: string | null | undefined): string | null {
	return projectId ? closing : null;
}

/** The agent knows a video once its audio went up, and hears that it is finished once. */
export function canAnnounce(closing: string | null, binding: VideoBinding | null): boolean {
	return !!closing && !!binding && binding.audioUploaded && !binding.learned;
}

export function closingMessage(closing: string, videoName: string): string {
	return `${closing} ${videoName}`;
}

/** The stretches a `<video>` reports in `played`, as seconds. */
export function playedSeconds(ranges: ReadonlyArray<readonly [number, number]>): number {
	return ranges.reduce((total, [start, end]) => total + (end - start), 0);
}

/** A seek to the end fires `ended` too, so the end only counts after half of the video played. */
export function watchedEnough(played: number, duration: number): boolean {
	return duration > 0 && played >= duration / 2;
}
